import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { QA_NAME_APPLICANT_CREDIT_CHECK_SUPPLEMENTARY } from '../ApplicantCreditCheckBlock.constants'
import { ApplicantCreditCheckDisclosure } from '../ApplicantCreditCheckDisclosure'
import { ApplicantCreditCheckResult } from '../ApplicantCreditCheckResult'

import * as styles from '../ApplicantCreditCheckBlock.module.css'

function ApplicantCreditCheckSupplementary({ canViewSensitive, results }) {
  const { t } = useTranslation()

  const [isOpen, setOpen] = useState(false)

  function handleToggle() {
    setOpen(!isOpen)
  }

  return (
    <ApplicantCreditCheckDisclosure
      isOpen={isOpen}
      qaName={QA_NAME_APPLICANT_CREDIT_CHECK_SUPPLEMENTARY}
      text={t('RentalPortal.ApplicantCreditCheckSupplementaryKey', {
        total: results.length,
      })}
      onToggle={handleToggle}
    >
      <div className={styles.rows}>
        {results.map(result => (
          <ApplicantCreditCheckResult
            canViewSensitive={canViewSensitive}
            key={result.id}
            result={result}
          />
        ))}
      </div>
    </ApplicantCreditCheckDisclosure>
  )
}

export default ApplicantCreditCheckSupplementary
